module.exports = __webpack_public_path__ + "static/media/pencil.15e39e75.gif";